export default (value: string, list: Array<string>): string | undefined => {
  if (!list.length) return undefined;

  let subStr = value;

  while (subStr) {
    const index = list.indexOf(subStr);
    if (index !== -1) return subStr;
    subStr = subStr.slice(0, -1);
  }

  return undefined;
};
